import axios from "axios";
import { apiHeaders } from "helper/apiHeader";

export const allTestListGet = (globalState, dispatchAllTest) => {
  axios
    .get(
      `${globalState.host}${globalState.apiEnd.metaData}`,
      apiHeaders(globalState.apiTask.testlistinfo)
    )
    .then((res) => {
      console.log("resres", res);
      if (res.data.status === "201") {
        dispatchAllTest({ type: "SET_ALL_TEST", payload: res.data.data });
      } else {
        console.log("API ERROR");
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getTestStudent = (data, globalState, dispatchAllTest) => {
  axios
    .post(
      `${globalState.host}${globalState.apiEnd.userTestData}`,
      { data: { ...data } },
      apiHeaders(globalState.apiTask.getplrwisesummary)
    )
    .then((res) => {
      console.log("resres", res);
      if (res.data.status === "201") {
        dispatchAllTest({
          type: "SET_ALL_TEST_STUDENT",
          payload: res.data.data,
        });
      } else if (res.data.status === "404") {
        dispatchAllTest({
          type: "SET_ALL_TEST_STUDENT",
          payload: "Not_Found",
        });
        console.log("API 404 request");
      } else {
        console.log("API ERROR");
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const asyncAllTestListGet = (globalState, dispatchAllTest) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${globalState.host}${globalState.apiEnd.metaData}`,
        apiHeaders(globalState.apiTask.testlistinfo)
      )
      .then((res) => {
        console.log("resres", res);
        if (res.data.status === "201") {
          dispatchAllTest({ type: "SET_ALL_TEST", payload: res.data.data });
          resolve();
        } else {
          console.log("API ERROR");
          reject();
        }
      })
      .catch((err) => {
        console.log(err);
        reject();
      });
  });
};
